import styled from 'styled-components';
import { FontWeightNormal } from 'autogen/design-tokens/tokens';
import Price from './Price';
import type { IPrice } from './shared/types';

export interface IPriceDiscount extends IPrice {
    priceSaving?: string;
}

const StyledPriceBefore = styled(Price)`
    && {
        white-space: nowrap;
        font-weight: ${FontWeightNormal};
        color: ${({ theme }) => theme.ColorTextSecondary};
        text-decoration: line-through;
        line-height: normal;
    }
`;

const StyledPriceSaving = styled(Price)`
    && {
        color: ${({ theme }) => theme.ColorTextSale};
        font-weight: ${({ theme }) => theme.TypographyBodyWeightDefault};
        margin-left: ${({ theme }) => theme.Spacing8};
    }
`;

const Container = styled.span`
    line-height: normal;
`;

export function PriceDiscount({ price, priceSaving, size = 12 }: IPriceDiscount) {
    return (
        <Container>
            <StyledPriceBefore price={price} size={size} />
            {priceSaving && <StyledPriceSaving price={priceSaving} size={size} />}
        </Container>
    );
}
